/**
 * @name results.controller:blockMyRating
 * @description
 * # blockMyRating
 * Controller for myRating block directive
 */
export default function ($scope,
                         $element,
                         $http,
                         $compile,
                         config,
                         CommonFunctions,
                         ugc
                         ) {
    'ngInject';

    $scope.init = () => {
        angular.extend($scope, window.horseData);
        delete window.horseData;

        $scope.getUgcData();
        $scope.showBubbleOnlyFirstTime();
    };

    /**
     * Error comment container status flag
     * @type {boolean}
     */
    $scope.isErrorCommentShown = false;

    /**
     * Error lightBox container status flag
     * @type {boolean}
     */
    $scope.isErrorLightBoxShown = false;

    /**
     * Save button disabled flag
     * @type {boolean}
     */
    $scope.isSaveBtnDisabled = true;

    /**
     * Save button label flag
     * @type {boolean}
     */
    $scope.isSaveLabelShown = true;

    /**
     * Tooltip info for calculate option
     * @type {object}
     */
    $scope.tooltip = {
        title: 'Will save this rating to the horse profile page',
        shouldShow: true,
        shown: {}
    };

    /**
     * Retrieves ugc data via ajax
     */
    $scope.getUgcData = () => {
        ugc.rpNavigationAuthReady().then((auth) => {
            if (!auth.user.isLoggedIn) {
                $scope.showErrorComment();
                return;
            }

            ugc.checkNotes().then(response => {
                const { customer_results_notes: hasCustomerNotes,
                    customer_race_results_notes: hasRaceNotes } =
                response.data.hasNotes || {};

                if (!hasRaceNotes) {
                    $scope.generalInfo = Object.assign({}, $scope.generalInfo, {
                        note: {
                            value: '',
                            isExists: false
                        }
                    });
                }

                if (!hasCustomerNotes && !hasRaceNotes) {
                    return;
                }

                ugc.get($scope.raceId, $scope).success((data) => {
                    if ((data.runnerNotes && data.runnerNotes.error) ||
                    (data.raceNote && data.raceNote.error)
                  ) {
                        $scope.showErrorComment();
                    } else {
                        $scope.hideErrorComment();
                        $scope.generalInfo = Object.assign({}, $scope.generalInfo, {
                            note: {
                                value: data.raceNote && data.raceNote.comment || '',
                                isExists: !!(data.raceNote && data.raceNote.comment)
                            }
                        });
                        data.runnerNotes.forEach((runnerRecord) => {
                            const item = $scope.items.find(({ runnerInfo }) =>
                            runnerInfo.horseId === +runnerRecord.horseId);

                            if (item) {
                                item.runnerInfo.comment = runnerRecord.comment;
                                item.runnerInfo.rating = runnerRecord.rating;
                                item.runnerInfo.ratingFlag = runnerRecord.ratingFlag;
                                item.runnerInfo.isExists = runnerRecord.isExists;
                            }
                        });
                        angular.forEach($scope.items, (item) => {
                            if (item.wgtAllowance === null) {
                                item.wgtAllowance = 0;
                            }
                            if (item.wgtStNative === null) {
                                item.wgtStNative = 0;
                            }
                            if (item.accumLengthNative === null) {
                                item.accumLengthNative = 0;
                            }
                        });
                    }
                }).error(() => $scope.showErrorComment());
            });
        });
    };

    $scope.getTooltipPosition = () => {
        const screenSize = CommonFunctions.getScreenSize();
        return screenSize === 'extraNarrow' ? 'left' : 'top';
    };

    /**
     * Close tooltip bubble
     */
    $scope.closeTooltip = () => {
        $scope.setBubbleStorage();
        $scope.tooltip.shouldShow = false;
        $scope.tooltip.shown = {};
    };

    /**
     * Input change handler for calculate checkbox
     * @param index
     */
    $scope.onCalculateChange = (index) => {
        $scope.toggleCalculate(index);
        $scope.enableSaveButton();
    };

    /**
     *
     * @param idx
     */
    $scope.setMaster = (idx) => {
        $scope.tooltip.shown = {};
        $scope.tooltip.shown[idx] = true;
        $scope.items[idx].runnerInfo.isMasterRating = !$scope.items[idx].runnerInfo.isMasterRating;
        $scope.enableSaveButton();
    };

    /**
     * Set localStorage when user first time on page
     */
    $scope.setBubbleStorage = () => {
        try {
            localStorage.setItem('showBubbleIfFirst', true);
        } catch (e) {
            console.warn('You are in a private mode, and we couldn\'t save your preference.');
        }
    };

    /**
     * Don't show bubble after user closed it
     */
    $scope.showBubbleOnlyFirstTime = () => {
        if (localStorage.getItem('showBubbleIfFirst')) {
            $scope.tooltip.shouldShow = false;
        }
    };

    /**
     * Reset all fields
     */
    $scope.clear = () => {
        let isExists;
        let horseId = null;
        $scope.lastChangedIdx = null;
        $scope.generalInfo = {
            note: {
                value: null,
                isExists: $scope.generalInfo.note.isExists
            },
            length: $scope.generalInfo.length
        };

        for (let i = 0, len = $scope.items.length; i < len; i++) {
            if ($scope.items[i].hasOwnProperty('runnerInfo')) {
                isExists = $scope.items[i].runnerInfo.isExists;
                horseId = $scope.items[i].runnerInfo.horseId;
                Object.keys($scope.items[i].runnerInfo).forEach(key => {
                    $scope.items[i].runnerInfo[key] = null;
                });
                // Restoring state of horseId and isExists to be used on backend side
                if (isExists) {
                    $scope.items[i].runnerInfo.isExists = isExists;
                }
                if (horseId) {
                    $scope.items[i].runnerInfo.horseId = horseId;
                }
            }
        }
        $scope.enableSaveButton();
    };

    /**
     * Submits ratings form
     */
    $scope.quickNotesSubmit = (event) => {
        const formData = {
            raceId: $scope.raceId,
            raceTypeCode: $scope.raceTypeCode,
            horses: $scope.items.map((item) => item.runnerInfo),
            note: $scope.generalInfo.note ? $scope.generalInfo.note.value : null,
            noteExists: $scope.generalInfo.note.isExists
        };

        ugc.post(formData).success((data) => {
            $scope.quickNotesCallback(event, data);
        }).error(() => {
            $scope.showErrorLightBox();
        });
    };

    /**
     * Callback for quickNotes ajax request
     * Updates status of horse if record was saved successfully
     *
     * @param {Object} event Event object
     * @param {Object} data Response object
     */
    $scope.quickNotesCallback = (event, data) => {
        if (data.quickNotes) {
            if (data.quickNotes.error) {
                $scope.showErrorLightBox();
            } else {
                Object.keys(data.quickNotes).forEach(key =>
                    $scope.setUgcStatus(key)
                );
                $scope.showSavedLabel();
            }
        } else {
            $scope.showSavedLabel();
        }

        $scope.setRaceNotesStatus(data.raceNotes);
    };

    /**
     * Updates Ugc status of horse (is record exists in UGC or not)
     *
     * @param {Number} horseId Id of the horse
     */
    $scope.setUgcStatus = (horseId) => {
        const item = $scope.items.find(horse => horse.runnerInfo.horseId === +horseId);
        if (item) {
            item.runnerInfo.isExists = !!
                (
                    item.runnerInfo.rating !== '' &&
                    (+item.runnerInfo.rating || +item.runnerInfo.rating === 0)
                ) || (
                    item.runnerInfo.comment &&
                    (item.runnerInfo.comment.trim() || item.runnerInfo.comment === 0)
                ) || (
                    item.runnerInfo.ratingFlag &&
                    (item.runnerInfo.ratingFlag.trim() || item.runnerInfo.ratingFlag === 0)
                );
        }
    };

    /**
     * Updates status of race comment depending if it was successfully updated on backend
     *
     * @param {Object} raceNotes
     */
    $scope.setRaceNotesStatus = (raceNotes) => {
        $scope.generalInfo.note.isExists =
            $scope.generalInfo.note.value !== '' && raceNotes && raceNotes.data.result === true;
    };

    /**
     * Run calculation on click Calculate button
     * Formula:
     * Basis rating - (distanceToWinner * entered on lb/length input value) -
     * (difference between current horse and basis horse)
     */
    $scope.calculateRating = () => {
        const idx = $scope.lastChangedIdx;
        const lbLength = $scope.generalInfo.length;
        const enteredRating = [];

        angular.forEach($scope.items, (value, index) => {
            if (value.runnerInfo.rating) {
                enteredRating[index] = value.runnerInfo.rating;
            }
        });

        const scopeItemByIndex = $scope.items[idx];
        const basisRating = scopeItemByIndex.runnerInfo.rating;

        const basisDistanceToWinner = scopeItemByIndex.accumLengthNative;
        const weightOfFirstHorse = parseInt(scopeItemByIndex.wgtStNative, 10) +
            parseInt(scopeItemByIndex.wgtAllowance, 10) +
            parseInt(scopeItemByIndex.wfaAdjustment, 10);

        angular.forEach($scope.items, (value, index) => {
            const isNonFinisher = isNaN(parseInt(value.outcomeCode, 10))
                && value.outcomeCode !== 'DSQ';
            const weightAllowance = parseInt(value.wgtAllowance, 10);
            const weightOfHorse = parseInt(value.wgtStNative, 10) +
                parseInt(value.wfaAdjustment, 10);

            let distanceToWinner = value.accumLengthNative;

            if (idx !== 0) {
                distanceToWinner -= basisDistanceToWinner;
            }

            const weightDifference = weightOfFirstHorse - (weightOfHorse + weightAllowance);
            let calculatedRating = Math.round(basisRating - (distanceToWinner * lbLength) -
                weightDifference);

            if (calculatedRating < 0 || isNonFinisher) {
                calculatedRating = '';
            }

            $scope.items[index].runnerInfo.rating = calculatedRating;
        });
    };

    /**
     * Input change handler for ratings inputs
     * @param idx
     * @param value
     */
    $scope.onRatingChange = (idx, value) => {
        $scope.enableSaveButton();
        $scope.validateMyRating(idx, value);
    };

    /**
     * Validation for myRating inputs
     * Only numbers and less/equal 500
     * @param {Number} idx index of current button
     * @param {Number} value Incoming typed value
     */
    $scope.validateMyRating = (idx, value) => {
        $scope.items[idx].runnerInfo.rating = $scope.validateLength(value, 500);
        $scope.lastChangedIdx = idx;
    };

    /**
     * Input change handler for Lbs / Length input
     * @param value
     */
    $scope.onLbsLengthChange = (value) => {
        $scope.enableSaveButton();
        $scope.validateLbLength(value);
    };
    /**
     * Validation for lb/length input
     * Only numbers and less/equal 10
     * @param {Number} value Incoming typed value
     */
    $scope.validateLbLength = (value) => {
        $scope.generalInfo.length = $scope.validateLength(value, 10);
    };

    /**
     * Main validation of myRating inputs
     * @param {String} value Incoming typed value
     * @param {Number} maxNumber Maximum value allowed here
     * @returns {String} validated data
     */
    $scope.validateLength = (value, maxNumber) => {
        let result;
        if (isNaN(value)) {
            result = '';
        } else if (parseFloat(value) > maxNumber) {
            result = maxNumber;
        } else {
            result = value;
        }

        return String(result);
    };

    /**
     * Enable Save button
     * set label to Save
     */
    $scope.enableSaveButton = () => {
        if (!$scope.isErrorCommentShown) {
            $scope.isSaveBtnDisabled = false;
            $scope.isSaveLabelShown = true;
        }
    };

    /**
     * Disables save button
     * set label to Saved
     */
    $scope.showSavedLabel = () => {
        $scope.isSaveBtnDisabled = true;
        $scope.isSaveLabelShown = false;
    };

    /**
     * Shows error messages after all inputs
     */
    $scope.showErrorComment = () => {
        if (!$scope.isErrorCommentShown) {
            $scope.isErrorCommentShown = true;
        }
    };

    /**
     * Hides error messages after all inputs
     */
    $scope.hideErrorComment = () => {
        $scope.isErrorCommentShown = false;
    };

    /**
     * Shows error lightBox
     */
    $scope.showErrorLightBox = () => {
        $scope.isErrorLightBoxShown = true;
    };

    /**
     * Removes error lightBox
     */
    $scope.hideErrorLightBox = () => {
        $scope.isErrorLightBoxShown = false;
    };

    /**
     * StopPropagation
     */
    $scope.stopPropagation = (e) => {
        e.stopPropagation();
    };

    $scope.init();
}



// WEBPACK FOOTER //
// ./src/js/controllers/myRating.js